import { appConfig } from "~/config/app";

type ShowcaseProjectData = {
  readonly name: string;
  readonly description: string;
  readonly image: string;
  readonly icon?: string;
  readonly href: string;
  readonly tags: readonly ("web" | "mobile" | "extension")[];
  readonly products: readonly ("core" | "ai" | "openclaw")[];
};

/* screenshot size - 1280 x 800 */
export const PROJECTS = [
  {
    name: "Statiko",
    description:
      "Monitor any Telegram channel in real time - track posts, edits, deletions, and growth with AI recaps 📡",
    image: "/images/landing/projects/statiko.webp",
    icon: "/images/landing/projects/icons/statiko.png",
    href: "https://statiko.io",
    tags: ["web"],
    products: ["core", "ai"],
  },
  {
    name: "Shibui",
    description:
      "AI website builder - describe your business, pick a niche template, edit by chatting, and publish instantly ✨",
    image: "/images/landing/projects/shibui.webp",
    icon: "/images/landing/projects/icons/shibui.png",
    href: "https://shibui.build/",
    tags: ["web"],
    products: ["core", "ai"],
  },
  {
    name: "Pro Service",
    description:
      "Find verified home service professionals, compare quotes, and pay securely through escrow - built for Brazilians across the US 🏠",
    image: "/images/landing/projects/pro-service.webp",
    href: "https://tryproservice.com/",
    tags: ["web"],
    products: ["core", "ai"],
  },
  {
    name: "RankGrow",
    description:
      "Fix your SEO with AI agents - connect Search Console, get prioritized tasks, and grow organic traffic 📈",
    image: "/images/landing/projects/rankgrow.webp",
    icon: "/images/landing/projects/icons/rankgrow.png",
    href: "https://www.rankgrow.io",
    tags: ["web"],
    products: ["core", "ai"],
  },
  {
    name: "SyncReads",
    description:
      "Sync your favorite content for distraction-free reading, save time and replace multiple apps. Anytime, anywhere 🔄",
    image: "/images/landing/projects/syncreads.webp",
    icon: "/images/landing/projects/icons/syncreads.png",
    href: "https://www.syncreads.com",
    tags: ["web", "mobile", "extension"],
    products: ["core", "ai"],
  },
  {
    name: "Omichat",
    description:
      "Chat with 50+ AI models, including ChatGPT and Claude, in one place - switch models anytime without losing context 🤖",
    image: "/images/landing/projects/omichat.webp",
    icon: "/images/landing/projects/icons/omichat.png",
    href: "https://www.omichat.app",
    tags: ["web"],
    products: ["ai"],
  },
  {
    name: "Socialcrawl",
    description:
      "Get clean, structured data from 21 platforms like TikTok, Instagram, and YouTube with a single request 📊",
    image: "/images/landing/projects/socialcrawl.webp",
    icon: "/images/landing/projects/icons/socialcrawl.png",
    href: "https://www.socialcrawl.dev",
    tags: ["web"],
    products: ["core", "ai"],
  },
  {
    name: "Claude Fast",
    description:
      "Supercharge your Claude Code with 6x effective context window and specialized AI agents 🤖",
    image: "/images/landing/projects/claude-fast.webp",
    icon: "/images/landing/projects/icons/claude-fast.png",
    href: "https://claudefa.st/",
    tags: ["web"],
    products: ["ai"],
  },
  {
    name: "EmojAI",
    description:
      "AI-powered emoji picker with smart, context-aware suggestions 🤖",
    image: "/images/landing/projects/emojai.webp",
    icon: "/images/landing/projects/icons/emojai.png",
    href: "https://chromewebstore.google.com/detail/emojai/gnnjegdgbplhcoadniflbacadnmlepoa",
    tags: ["extension"],
    products: ["ai"],
  },
  {
    name: "Solohacker",
    description:
      "Autonomous company launcher - AI agents work 24/7, escalate what matters, and you stay in control 🤖",
    image: "/images/landing/projects/solohacker.webp",
    icon: "/images/landing/projects/icons/solohacker.png",
    href: "https://www.solohacker.org",
    tags: ["web"],
    products: ["openclaw"],
  },
  {
    name: "Dotallio",
    description:
      "Personalized AI apps that automate research, data extraction, and content creation without code 🤖",
    image: "/images/landing/projects/dotallio.webp",
    icon: "/images/landing/projects/icons/dotallio.png",
    href: "https://www.dotallio.com",
    tags: ["web", "extension"],
    products: ["core"],
  },
  {
    name: "Talk to Santa",
    description:
      "Enjoy a magical live video chat or receive a unique AI-generated video greeting from Santa Claus 🎅",
    image: "/images/landing/projects/santa.webp",
    icon: "/images/landing/projects/icons/santa.png",
    href: "https://santacall.vercel.app/",
    tags: ["web"],
    products: ["core"],
  },
  {
    name: "pozywka.pl",
    description:
      "Scalable blog for food journalist, focused on performance and user experience 🌭",
    image: "/images/landing/projects/pozywka.webp",
    icon: "/images/landing/projects/icons/pozywka.png",
    href: "https://www.pozywka.pl",
    tags: ["web"],
    products: ["core"],
  },
  {
    name: "zagrodzki.me",
    description:
      "Personal blog and portfolio of Bart Zagrodzki, where he shares his knowledge and work 💼",
    image: "/images/landing/projects/zagrodzki.webp",
    icon: "/images/landing/projects/icons/zagrodzki.png",
    href: "https://www.zagrodzki.me",
    tags: ["web"],
    products: ["core"],
  },
  {
    name: "TurboStarter",
    description: appConfig.title,
    image: "/images/landing/projects/turbostarter.webp",
    icon: "/images/landing/projects/icons/turbostarter.png",
    href: "https://www.turbostarter.dev",
    tags: ["web", "mobile", "extension"],
    products: ["core", "ai"],
  },
  // {
  //   name: "Finejob",
  //   description:
  //     "Created for developers (but not only 😁) to help them get a dream job 💼",
  //   image: "/images/landing/projects/finejob.webp",
  //   href: "https://www.zagrodzki.me/work/finejob",
  //   tags: ["web", "mobile"],
  // },
  {
    name: "BeRawi: Storytelling Coach",
    description:
      "Practice storytelling daily with instant feedback to sound clearer, more engaging, and confident 🎤",
    image: "/images/landing/projects/berawi.webp",
    icon: "/images/landing/projects/icons/berawi.png",
    href: "https://berawi.com",
    tags: ["mobile"],
    products: ["ai"],
  },
  {
    name: "HTML to Markdown",
    description:
      "Convert HTML to Markdown with ease, directly in your browser 📄",
    image: "/images/landing/projects/html-to-markdown.webp",
    icon: "/images/landing/projects/icons/html-to-markdown.png",
    href: "https://chromewebstore.google.com/detail/html-to-markdown/kofbbilhmnkcmibjbioafflgmpkbnmme",
    tags: ["extension"],
    products: ["core"],
  },
] as const satisfies readonly ShowcaseProjectData[];

export type ShowcaseProject = ShowcaseProjectData;
export type ShowcaseTag = ShowcaseProject["tags"][number];
export type ShowcaseKit = ShowcaseProject["products"][number];
